import { render } from "./Founder2.vue?vue&type=template&id=455e5095&scoped=true"
import script from "./Founder2.vue?vue&type=script&lang=js"
export * from "./Founder2.vue?vue&type=script&lang=js"

import "./Founder2.vue?vue&type=style&index=0&id=455e5095&scoped=true&lang=css"

import exportComponent from "/mnt/data/workspace/risetai/riset.ai-website/Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455e5095"]])

export default __exports__